/**
 * Legacy ThemesApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.themesApi`) keep resolving.
 *
 * The actual ThemesApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/themes/themes-api.service.ts
 */
angular.module("acme.common.service.themesApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
